import React, { useState } from 'react';
import FormControl from '@material-ui/core/FormControl';
import FormLabel from '@material-ui/core/FormLabel';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import RadioGroup from '@material-ui/core/RadioGroup';
import Radio from '@material-ui/core/Radio';
import { getISODate } from '../../../services/calendar/DateTools';
import DateInput from '../../../app/common/ui/DateInput';
import Grid from '@material-ui/core/Grid'

const ServiceDateInput = ({ id, label, dateConstraint, onChange, byDate = true, onDate = true, dateRange = true }) => {
    const [constraint, setConstraint] = useState(dateConstraint);

    const handleChange = ({ target: { value } }) => {
        setConstraint({ ...constraint, type: value });
    }

    const handleDateChange = (index, date) => {
        const updated = { ...constraint };
        updated.values[index] = getISODate(new Date(date));

        if (updated.type === 'dateRange' && updated.values?.length > 1 && updated.values.every(dt => !isNaN(Date.parse(dt)))) {
            console.log('date constraint', updated)
            onChange(updated);
        }
        else {
            onChange(updated);
        }

        setConstraint(updated);
    }

    return <div>
        <Grid container spacing={1} alignContent="center" alignItems="flex-end">
            <Grid item xs={12} lg={3}>
                <FormControl component="fieldset">
                    <FormLabel component="legend">{label}</FormLabel>
                    <RadioGroup
                        row
                        aria-label="date required"
                        value={constraint.type}
                        onChange={handleChange}>
                        {byDate ? <FormControlLabel value="byDate" label="By" control={<Radio />} /> : <></>}
                        {onDate ? <FormControlLabel value="onDate" label="On" control={<Radio />} /> : <></>}
                        {dateRange ? <FormControlLabel value="dateRange" label="Between" control={<Radio />} /> : <></>}
                    </RadioGroup>
                </FormControl>
            </Grid>
            <Grid item xs={12} md={3}>
                <DateInput value={constraint.values[0]}
                    required={true}
                    hint={constraint.type === 'dateRange' ? 'First Date' : 'On Date'}
                    onChange={date => handleDateChange(0, date)} />
            </Grid>
            <Grid item xs={12} md={3}>
                {
                    constraint.type === 'dateRange' &&
                    <DateInput value={constraint.values[1]}
                        required={true}
                        hint="Last date"
                        onChange={date => handleDateChange(1, date)} />

                    // <DatePicker style={{ marginLeft: '1rem' }} label="Until" value={constraint.values[1]} onChange={date => handleDateChange(1, date)} /> 
                }

            </Grid>
        </Grid>
        {/* 
        <DatePicker 
            label={inputLabels[constraint.type]} 
            value={constraint.values[0]} 
            onChange={date => handleDateChange(0, date)} /> */}
    </div>
};

export { ServiceDateInput };